import {
  keikkaBetoni_cacheName,
  cache_clear,
  cache_read,
  cache_write,
  keikka_cacheName,
} from "src/components/js/CacheFunctions";
import { checkResponse } from "src/components/js/statics1";

export const RasitusLuokatArr = [
  "X0",
  "XC1",
  "XC2",
  "XC3",
  "XC4",
  "XD1",
  "XD2",
  "XD3",
  "XF1",
  "XF2",
  "XF3",
  "XF4",
  "XS1",
  "XS2",
  "XS3",
  "XA1",
  "XA2",
  "XA3",
];

export function betoni_getStrings(betoni) {
  if (!betoni) return null;
  const betoniStrings = [];
  betoniStrings.push(betoni_getString_noAttr(betoni));
  if (betoni.betoniComment) betoniStrings.push(betoni.betoniComment);
  const attrs = betoni.attr?.attr || betoni.attr || [];
  attrs.forEach((attr) => {
    const attrString =
      attr.attrNimike + (attr.keikkaBetoniAttrComment ? ": " + attr.keikkaBetoniAttrComment : "");
    if (attrString) betoniStrings.push(attrString);
  });
  return betoniStrings;
}

export function betoni_getString(betoni, noAttr = false) {
  if (!betoni) return "";
  // Get the base concrete string
  const baseString = betoni_getString_noAttr(betoni);
  // Extract attributes if they exist
  const attrs = betoni.attr?.attr || betoni.attr || [];
  // const attrString = attrs.map((attr) => attr.attrNimike).join(", ");
  let attrString = "";
  if (!noAttr) {
    try {
      attrs.forEach((attr) => {
        if (attr.attrNimike) attrString += attr.attrNimike;
        if (attr.keikkaBetoniAttrComment) attrString += ": " + attr.keikkaBetoniAttrComment;
        // add comma if not last
        if (attr.keikkaBetoniAttrId !== attrs[attrs.length - 1].keikkaBetoniAttrId)
          attrString += ", ";
      });
    } catch (e) {
      console.error("Error processing betoni attributes:", e);
    }
  }

  // Combine strings, clean up, and validate length
  const combinedString = removeEiTietoaFromBetoniString(
    [baseString, attrString].filter((s) => s).join(" ")
  );
  const a = combinedString.length > 4 ? combinedString : "";
  return a;
}

function removeEiTietoaFromBetoniString(betoniString) {
  if (!betoniString) return "";

  // Use a single regex pattern for better performance
  const cleanString = betoniString
    .replace(/(?:Ei tietoa|ei tietoa|undefined)/g, "")
    // Handle multiple spaces that might result from removed text
    .replace(/\s+/g, " ")
    .trim();

  return cleanString;
}

export function betoni_getString_noAttr(betoni) {
  if (!betoni) return "";

  const notkeus =
    (
      betoni.notkeus?.notkeusSelite ||
      betoni.notkeus?.notkeusString ||
      betoni.notkeusSelite
    )?.trim() || "";
  const kayttoIka =
    (
      betoni.kayttoIka?.kayttoIkaSelite ||
      betoni.kayttoIka?.kayttoIkaString ||
      betoni.kayttoIkaSelite
    )?.trim() || "";
  const raeKoko =
    (
      betoni.raeKoko?.raeKokoSelite ||
      betoni.raeKoko?.raeKokoString ||
      betoni.raeKokoSelite
    )?.trim() || "";

  // Define properties to extract and join
  const parts = [
    (betoni.laatu?.laatuNimike || betoni.laatu?.nimike || betoni.laatuNimike)?.trim() || "",
    betoni.isNopea ? "nopea" : "",
    raeKoko,
    (betoni.lujuus?.lujuusSelite || betoni.lujuus?.lujuusString || betoni.lujuusSelite)?.trim() ||
      "",
    notkeus,
    (betoni.rasitus?.rasitusluokatString || betoni.rasitusluokat)?.trim() || "",
    kayttoIka,
  ];

  // Join non-empty parts with a single space
  const result = parts.filter((part) => part).join(" ");

  return removeEiTietoaFromBetoniString(result);
}

export async function keikka_fetchKeikkaId_by_foreignKey(foreignKey, token) {
  const url1 = import.meta.env.VITE_SERVER_URL + "/api/keikka/getByForeignKey/" + foreignKey;
  const c = cache_read(keikka_cacheName, url1);
  if (c) return c;
  const response = await fetch(url1, {
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  });
  const cResponse = await checkResponse(response, "keikkaClass.js:getKeikkaIdOriginByForeignKey");
  if (!cResponse.success) return false;
  const result = cResponse.data;
  let _keikkaId = null;
  let _originId = 1;
  if (result.length > 0) {
    _keikkaId = result[0].keikkaId;
    _originId = result[0].originId;
    cache_write(keikka_cacheName, url1, { keikkaId: _keikkaId, originId: _originId }, 3600);
  }
  return { keikkaId: _keikkaId, originId: _originId };
}

export async function betoni_fetchKayttoIkaList() {
  const url = import.meta.env.VITE_SERVER_URL + "/api/betoni/kayttoika/list";
  const c = cache_read(keikkaBetoni_cacheName, url);
  if (c) return c;
  const response = await fetch(url);
  const json = await response.json();
  cache_write(keikkaBetoni_cacheName, url, json, 0);
  return json;
}
export async function betoni_fetchLujuusList() {
  const url = import.meta.env.VITE_SERVER_URL + "/api/betoni/lujuus/list";
  const c = cache_read(keikkaBetoni_cacheName, url);
  if (c) return c;
  const response = await fetch(url);
  const json = await response.json();
  cache_write(keikkaBetoni_cacheName, url, json, 0);
  return json;
}
export async function betoni_fetchNotkeusList() {
  const url = import.meta.env.VITE_SERVER_URL + "/api/betoni/notkeus/list";
  const c = cache_read(keikkaBetoni_cacheName, url);
  if (c) return c;
  const response = await fetch(url);
  const json = await response.json();
  cache_write(keikkaBetoni_cacheName, url, json, 0);
  return json;
}
export async function betoni_saveTarjousHintaToDB(betoni, token) {
  const addr = "/api/tarjous/betoni/hinta/set";
  const keikkaBetoniId = betoni.keikkaBetoniId;
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      keikkaBetoniId: keikkaBetoniId,
      hinta_value: betoni.hinta_value,
      hinta_muistiinpanot: betoni.hinta_muistiinpanot,
    }),
  };
  const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, requestOptions)
    .then((response) => {
      if (!response.ok) {
        throw Error("Save failed");
      }
      return response;
    })
    .catch((error) => {
      throw Error(error);
    });
  return response;
}
export async function betoni_saveRasitusToDB(betoni, token, varmenne = null, keikkaId = 0) {
  cache_clear(keikkaBetoni_cacheName);
  const keikkaBetoniId = betoni.keikkaBetoniId;
  if (keikkaBetoniId === 0) return;
  let rasitusluokat = betoni.rasitus?.rasitusluokat || betoni.rasitusluokat;
  // if rasitusluokat is string, convert to array
  if (typeof rasitusluokat === "string") {
    rasitusluokat = rasitusluokat.split(",");
  }
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      keikkaBetoniId: keikkaBetoniId,
      rasitusluokat: rasitusluokat,
      keikkaId: keikkaId,
      varmenne: varmenne,
      commonHash: betoni.commonHash,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/keikka/betoni/rasitus/set",
    requestOptions
  ).catch((error) => console.log(error));
  if (!(await checkResponse(response).success)) return false;
}
export async function betoni_saveSlidersToDB(betoni, token, varmenne = null, keikkaId = 0) {
  cache_clear(keikkaBetoni_cacheName);
  const addr = "/api/keikka/betoni/setSliders";
  const keikkaBetoniId = betoni.keikkaBetoniId;
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      keikkaBetoniId: keikkaBetoniId,
      laatuId: betoni.laatu?.laatuId || betoni.laatuId,
      isNopea: betoni.isNopea,
      raeKokoId: betoni.raeKoko?.raeKokoId || betoni.raeKokoId,
      lujuusId: betoni.lujuus?.lujuusId || betoni.lujuusId,
      notkeusId: betoni.notkeus?.notkeusId || betoni.notkeusId,
      raeKokoText: betoni.raeKoko?.raeKokoText || betoni.raeKokoSelite,
      lujuusText: betoni.lujuus?.lujuusText || betoni.lujuusSelite,
      notkeusText: betoni.notkeus?.notkeusText || betoni.notkeusSelite,
      kayttoIkaId: betoni.kayttoIka?.kayttoIkaId || betoni.kayttoIkaId,
      varmenne: varmenne,
      keikkaId: keikkaId,
      commonHash: betoni.commonHash,
    }),
  };
  const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, requestOptions)
    .then((response) => {
      if (!response.ok) {
        throw Error("Save failed");
      }
      return response;
    })
    .catch((error) => {
      throw Error(error);
    });
  return response.ok;
}
export async function betoni_fetchKeikkaBetonit(keikkaId, token) {
  const url = import.meta.env.VITE_SERVER_URL + "/api/keikka/betoni/list/" + keikkaId;
  const c = cache_read(keikkaBetoni_cacheName, url);
  if (c) return c;
  const response = await fetch(url, {
    headers: {
      "x-access-token": `${token}`,
    },
  });
  const json = await response.json();
  cache_write(keikkaBetoni_cacheName, url, json, 0);
  return json;
}
export async function betoni_fetchShortCuts(asiakasId, token) {
  const url = import.meta.env.VITE_SERVER_URL + "/api/betoni/shortCuts/list/" + asiakasId;
  const c = cache_read(keikkaBetoni_cacheName, url);
  if (c) return c;
  const response = await fetch(url, {
    headers: {
      "x-access-token": `${token}`,
    },
  });
  const json = await response.json();
  cache_write(keikkaBetoni_cacheName, url, json, 0);
  return json;
}
export async function betoni_shortCuts_Add(asiakasId, shortCut, token) {
  const url = import.meta.env.VITE_SERVER_URL + "/api/betoni/shortCuts/add/" + asiakasId;
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ shortcut: shortCut }),
  };
  const response = await fetch(url, requestOptions);
  cache_clear(keikkaBetoni_cacheName);
  return response.ok;
}
export async function betoni_shortCuts_save(asiakasId, shortCutData, token) {
  const url = import.meta.env.VITE_SERVER_URL + "/api/betoni/shortCuts/save/" + asiakasId;
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(shortCutData),
  };
  const response = await fetch(url, requestOptions);
  const json = await response.json();
  cache_clear(keikkaBetoni_cacheName);
  return json;
}
export async function betoni_shortCuts_delete(betoniShortCutId, token) {
  const url = import.meta.env.VITE_SERVER_URL + "/api/betoni/shortCuts/delete/" + betoniShortCutId;
  const requestOptions = {
    method: "DELETE",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(url, requestOptions);
  cache_clear(keikkaBetoni_cacheName);
  return response.ok;
}

export function betoni_isComplete(betoni) {
  if (!betoni) return { isComplete: false, reason: "Virhe: Betonia ei ole" };
  if (!betoni.laatuId && !betoni.laatu?.laatuId)
    return { isComplete: false, reason: "Laatua ei ole valittu" };
  if (!betoni.raeKokoId && !betoni.raeKoko?.raeKokoId)
    return { isComplete: false, reason: "Raekokoa ei ole valittu" };
  if (!betoni.lujuusId && !betoni.lujuus?.lujuusId)
    return { isComplete: false, reason: "Lujuutta ei ole valittu" };
  if (!betoni.notkeusId && !betoni.notkeus?.notkeusId)
    return { isComplete: false, reason: "Notkeutta ei ole valittu" };
  if (!betoni.kayttoIkaId && !betoni.kayttoIka?.kayttoIkaId)
    return { isComplete: false, reason: "Käyttöikää ei ole valittu" };
  return { isComplete: true, reason: "" };
}
